<!--
 * @title: 页面名称
 * @Description: 
 * @Version: 2.0
 * @Autor: 研发三部
 * @Date: 2020-12-03 09:37:11
 * @LastEditors: jinzb
 * @LastEditTime: 2020-12-28 16:01:28
-->
<template>
    <div class="content">
        <div class="block">
            <span class="resource-title" @click="changeActiveComponents('resourceStatus')"> <i
                    class="el-icon-minus title_icon"></i>资源状况</span>
            <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="100%">
                <!-- <centerLeft1 /> -->
                <div style="height: 100%;">
                    <div style="margin: 0 5%;height: 14%;font-size: 1vw;color:#fff;position: relative;top: 0px;left: 0px;">
                        <div style="height: 100%;position: absolute;top:2%;left:5%;width:100%;display: flex;
  justify-content: center;
  flex-direction: column
">
                            <div>草地面积：&nbsp;&nbsp;&nbsp;&nbsp;<span
                                    style="color:#00fefd;font-size: 1.2vw;padding-left: 5%;">9027.32万亩</span></div>
                            <div>草地类型：&nbsp;&nbsp;&nbsp;&nbsp;<span
                                    style="color:#00fefd;font-size: 1.2vw;padding-left: 5%;">5类23型</span></div>
                        </div>

                    </div>

                    <div style="margin: 0 5%; height: 43%;">
                        <leftTop></leftTop>
                    </div>
                    <div style="margin: 0 5%;height: 43%;">
                        <leftBottom></leftBottom>
                    </div>
                </div>

            </dv-border-box-1>
        </div>
        <div class="block">
            <div class="image_title">
                草地类分布图
            </div>
            <div style=" height: 55%;width: 100%;border-radius: 10px;">
                <el-carousel :interval="5000" arrow="always" style="height: 100%;">
                    <el-carousel-item v-for="item in 4" :key="item" style="height: 100%;">
                        <el-image :src="require('@/assets/large-screen-img/gl1.png')" fit="fit"
                            style="width: 100%;height: 100%;"></el-image>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div style="height: 45%;width: 100%;">
                <span class="resource-title" @click="changeActiveComponents('pestStatus')"> <i
                        class="el-icon-minus title_icon"></i>草原有害生物状况</span>
                <dv-border-box-1 style="height: 88%;" backgroundColor="rgba(14, 45, 40,0.5)">
                    <!-- <centerLeft1 /> -->
                    <div style=" padding: 16px;height: 100%;width: 100%;border-radius: 10px;">
                    </div>
                </dv-border-box-1>
            </div>
            <!-- <dv-border-box-12 style="height: 45%;">
                        <div style=" padding: 16px;height: 100%;width: 100%;border-radius: 10px;">
                        </div>
                    </dv-border-box-12> -->
            <!-- <div style="border: 1px #00ffff solid; height: 45%;width: 100%;border-radius: 10px;">
                        image
                    </div> -->
        </div>
        <div class="block">
            <span class="resource-title" @click="changeActiveComponents('ecologicalCondition')"> <i
                    class="el-icon-minus title_icon"></i>生态状况</span>
            <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="100%">
                <!-- <centerLeft1 /> -->
                <div style="margin: 0 5%;height: 100%;">
                    <div style="height: 50%;">
                        <div style="height: 10%;font-size: 0.8vw;color:#fff;position: relative;top: 0px;left: 0px;">
                            <div style="height: 100%;position: absolute;top:13%;left:5%;width:100%;display: flex;
  justify-content: center;
  flex-direction: column">
                                <div style="height: 100%;">退化草原（轻度、中度和重度）面积<span
                                        style="color:#00fefd;font-size: 1vw;padding-left: 5%;">4365.64万亩</span></div>
                            </div>
                        </div>
                        <div style="height: 90%;">

                            <rightTop></rightTop>


                        </div>

                    </div>
                    <div style="height: 50%;;">

                        <div style="height: 10%;font-size: 1vw;color:#fff;position: relative;top: 0px;left: 0px;">
                            <div style="height: 100%;position: absolute;top:13%;left:5%;width:100%;display: flex;
  justify-content: center;
  flex-direction: column">
                                <div style="height: 100%;">综合植被盖度&nbsp;&nbsp;&nbsp;&nbsp;<span
                                        style="color:#00fefd;font-size: 1vw;padding-left: 5%;">64.25%</span></div>
                            </div>

                        </div>
                        <div style="height: 90%;">

                            <rightBottom></rightBottom>


                        </div>

                    </div>

                </div>




            </dv-border-box-1>
        </div>
    </div>
</template>
<script>

import leftTop from "../comp/shouye/leftTop.vue";
import leftBottom from "../comp/shouye/leftBottom.vue";
import rightBottom from "../comp/shouye/rightBottom.vue";
import rightTop from "../comp/shouye/rightTop.vue";


export default {
    components: { leftTop, leftBottom, rightBottom, rightTop },
    props: {
        show: {
            type: Boolean,
            default: true
        },
        maptype: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
        };
    },
    mounted() {

    },
    methods: {
        changeActiveComponents(val) {
            //修改父组件传来的值
            this.$emit("changeActiveComponents", val)
        },
    }
};
</script>
  
  
<style lang="scss"  scoped>
/deep/ .el-carousel__arrow {
    font-weight: 800;
    font-size: 2vw;
    line-height: 2vw;
}

/deep/ .el-carousel__container {
    height: 100%;
}

.image_title {
    font-style: oblique;
    text-align: center;
    color: #00ffff;
    font-size: 1.5vw;
    height: 40px;
    line-height: 40px;
    font-weight: 500;
}

.title_icon {
    transform: rotate(90deg);
    font-weight: 700;
    color: #00ffff;
}

.resource-title {
    color: #fff;
    font-size: 1.5vw;
    height: 40px;
    line-height: 40px;
    margin-top: -10px;
    font-weight: 500;
}

.image_base {
    width: 100%;
    height: 100%;
    padding: 16px 16px 0 16px;
    background-image: url("../../../assets/large-screen-img/ditu.png");
    background-size: cover;
    background-position: center center;
}
</style>
  
  